import $ from 'jquery';

export default class CustomSelect {
	constructor() {
		this.selectBox = $('.custom-select');
		this.select = $('.custom-select_select');
	}

	init() {
		this.selectBox.each(function () {
			$(this).children('select').css('display', 'none');

			const $current = $(this);

			$(this).find('option').each(function (i) {
				if (i === 0) {
					$current.prepend($('<div>', {
						class: $current.attr('class').replace(/custom-select/g, 'custom-select__box')
					}));

					const placeholder = $(this).text();
					$current.prepend($('<span>', {
						class: $current.attr('class').replace(/custom-select/g, 'custom-select__placeholder'),
						text: placeholder
					}));
					return;
				}

				$current.children('div').append($('<span>', {
					class: $current.attr('class').replace(/custom-select/g, 'custom-select__options'),
					text: $(this).text()
				}));
			});
		});

		this.selectBox.click(function () {
			$(this).toggleClass('custom-select_active');
		});

		$('.custom-select__options').on('click', function () {
			const txt = $(this).text();

			$(this).siblings('.custom-select__options').removeClass('selected');
			$(this).addClass('selected');

			const currentSel = $(this).closest('.custom-select');
			currentSel.children('.custom-select__placeholder').text(txt);
			if (txt === 'Windows') {
				currentSel.removeClass('custom-select_kaspersky custom-select_android').addClass('custom-select_windows');
			}else if (txt === 'Android') {
				currentSel.removeClass('custom-select_kaspersky custom-select_windows').addClass('custom-select_android');
			}else if (txt === 'My Kaspersky') {
				currentSel.removeClass('custom-select_windows custom-select_android').addClass('custom-select_kaspersky');
			}
		});

	}
}



// WEBPACK FOOTER //
// ./app/blocks/custom-select/index.js